// mixin.js
import Vue from 'vue';
import Component from 'vue-class-component';

// You can declare a mixin as the same style as components.
@Component
export default class IsMobileMixin extends Vue {
    public isMobile = false;

    public isTablet = false;

    public innerWidth = window.innerWidth;

    public innerHeight = window.innerHeight;

    public mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize, { passive: true });
    }

    public beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize);
        }
    }

    public onResize() {
        this.isMobile = window.innerWidth <= 600;
        this.isTablet = window.innerWidth <= 900;
        this.innerWidth = window.innerWidth;
        this.innerHeight = window.innerHeight;
    }
}
